import React from "react";

// views
import Tutor from "./views/chat/Tutor";
import Socrates from "./views/chat/Socrates";
import Profile from "./views/settings/Profile";
import Login from "./views/settings/Login";
import GuideView from "./views/guide/GuideView";
import Products from "./views/settings/Products";
import Test from "./views/settings/Products copy";
import PaymentSuccess from "./views/settings/PaymentSuccess";
import Persona from "./views/settings/Persona";
import Order from "./views/settings/Order";
import OrderListV2 from "./views/orderListV2";
import Result from "./views/chat/components/Result";
import Form from "./views/chat/components/Form";
import SharePage from "./views/chat/SharePage";
import TutorV2 from "./views/tutorV2";
import MyAirV2 from "./views/myAirV2";
import MyActivityV2 from "./views/myActivityV2";
import SocratesV2 from "./views/socratesV2";
import CompanyInfo from "./views/companyInfo";
import Subscription from "./views/subscription/Subscription";
import SubscriptionTest from "./views/subscription/SubscriptionTest";
import SubscriptionComplete from "./views/subscription/SubscriptionComplete";
import AppBuyList from "./views/appBuyList";

// Feature flag to toggle between legacy Tutor and new TutorV2
// Set REACT_APP_USE_TUTOR_V2=true in .env to enable TutorV2
const useTutorV2 = process.env.REACT_APP_USE_TUTOR_V2 === "true";
const TutorComponent = useTutorV2 ? TutorV2 : Tutor;

const routes = [
  {
    path: "/",
    exact: true,
    name: "메인",
    element: TutorV2,
    isParams: true,
  },
  {
    path: "/tutor",
    exact: true,
    name: "튜터",
    element: TutorV2,
    isParams: true,
  },
  // TODO: V2 테스트용 routes 추가
  // {
  //   path: "/tutor-v2",
  //   exact: true,
  //   name: "튜터",
  //   element: TutorV2,
  //   isParams: true,
  // },
  {
    path: "/my-air",
    exact: true,
    name: "튜터",
    element: MyAirV2,
    isParams: true,
  },
  {
    path: "/my-activity",
    exact: true,
    name: "나의 활동",
    element: MyActivityV2,
    isParams: false,
  },
  {
    path: "/company-info",
    exact: true,
    name: "회사 정보",
    element: CompanyInfo,
    isParams: false,
  },
  // Socrates V2 (새로운 RESTful API)
  {
    path: "/socrates",
    exact: true,
    name: "소크라테스",
    element: SocratesV2,
    isParams: true,
  },
  {
    path: "/socrates/new",
    exact: true,
    name: "소크라테스 만들기",
    element: SocratesV2,
    isParams: false,
  },
  {
    path: "/socrates/:id",
    exact: true,
    name: "소크라테스 면접",
    element: SocratesV2,
    isParams: true,
  },
  {
    path: "/socrates/:id/result",
    exact: true,
    name: "소크라테스 결과",
    element: SocratesV2,
    isParams: true,
  },
  {
    path: "/socrates-legacy",
    exact: true,
    name: "소크라테스",
    element: Socrates,
    isParams: true,
  },
  {
    path: "/socrates/custom",
    exact: true,
    name: "나만의 소크라테스",
    element: Form,
    isParams: true,
  },
  {
    path: "/result",
    exact: true,
    name: "면접 결과",
    element: Result,
    isParams: true,
  },
  {
    path: "/share/:uuid",
    exact: true,
    name: "공유",
    element: SharePage,
    isParams: true,
  },
  {
    path: "/settings",
    exact: true,
    name: "마이페이지",
    element: Profile,
    isParams: false,
  },
  {
    path: "/settings/payment-success",
    exact: true,
    name: "결제 완료",
    element: PaymentSuccess,
    isParams: false,
  },
  {
    path: "/guide/:guideId",
    exact: true,
    name: "이용가이드",
    element: GuideView,
    isParams: true,
  },
  {
    path: "/my-activity",
    exact: true,
    name: "나의 활동",
    element: MyActivityV2,
    isParams: false,
  },
  {
    path: "/settings/products",
    exact: true,
    name: "요금제 안내",
    element: Products,
    isParams: false,
  },
  {
    path: "/settings/test",
    exact: true,
    name: "요금제 안내",
    element: Test,
    isParams: false,
  },
  {
    path: "/settings/persona",
    exact: true,
    name: "역할/어투설정",
    element: Persona,
    isParams: false,
  },
  {
    path: "/settings/order-list",
    exact: true,
    name: "결제내역",
    element: Order,
    isParams: false,
  },
  {
    path: "/order-list",
    exact: true,
    name: "이용 내역",
    element: OrderListV2,
    isParams: false,
  },
  {
    path: "/subscription",
    exact: true,
    name: "구독",
    element: Subscription,
    isParams: false,
  },
  {
    path: "/subscription/test",
    exact: true,
    name: "구독 테스트",
    element: SubscriptionTest,
    isParams: false,
  },
  {
    path: "/subscription-complete",
    exact: true,
    name: "구독 완료",
    element: SubscriptionComplete,
    isParams: false,
  },
  {
    path: "/app-buy-list",
    exact: true,
    name: "구매 내역",
    element: AppBuyList,
    isParams: false,
  },
  {
    path: "/login",
    exact: true,
    name: "로그인",
    element: Login,
    isParams: false,
  },
];

export default routes;
